 
 
     <!-- Page Content -->
     <div class="content content-full" *ngIf="isLoadingData===true">
       Loading data
     </div>
 
     <div class="content content-full" *ngIf="isLoadingData===false">
 
     <div class=row>
 
       <div class="col-sm-5">
 
         Show
         <select (change)="changeNumberOfRecords()" [(ngModel)]="numberOfRecords">
           <option value=15>15</option>
             <option value=30>30</option>
             <option value=60>60</option>
             <option value=99999>All</option>
         </select>
         entries
 
         <button class="btn" (click)="today()" style="margin-left:25px">Today</button>
 
       </div>
 
 
       <div class="col-sm-7 text-right">
           Search: <input type="text" [(ngModel)]="search">
       </div>
 
     </div>
 
 
 
     <div class="table yearDataTable">
  
     <div class="xrow header gridRow row">
      <div class="colDate">Date</div> 
      <div class="colServices">Holy Eucharist</div>
      <div class="colDailyOffice">Daily Office</div>
      <div class="colNotes">Notes</div>
     </div>
 
     <div id="scrollableTable">

       <div *ngFor="let date of data | calendarFilter: search| paginate: { itemsPerPage: numberOfRecords, currentPage: pageNumber }; let i = index" [ngClass]="getClasses(date)">
  
        <div class="gridRow row">
          
        <div class="colDate"> 
          <div class="@multipleServiceClass">{{date.DateDayStr}}</div>
          <div class="@multipleServiceClass">{{date.ShortDateStr}}</div>
        </div>

 

        <div class="colServices">
            
          <span *ngFor="let service of date.Services | calendarServiceHolyEucharistFilter; let odd=odd; let even=even" class="colServicesGrid">
   
            <div class="colors"> 
                <app-vestment-color-display [colors]="service.VestmentColors"></app-vestment-color-display>
            </div>
 
            <div class="serviceName" (click)="showServiceProperties(service, date, 1)">
              <span class='title link'>{{service.AdjustedServiceName}}</span> 
            </div> 

          </span>

        </div> 
        
        <div class="colDailyOffice">
          <div class="link" (click)="selectServiceForLiturgyType(date, 2)">Morning Prayer</div>
          <div class="link" (click)="selectServiceForLiturgyType(date, 3)">Evening Prayer</div>
        </div>

        <div class="colNotes">
           
          <span *ngFor="let note of date.CalendarItems; let odd=odd; let even=even">
   
              <div class="noteName" (click)="showNoteProperties(note)">
                <span class='title link'>{{note.Name}}</span> 
              </div> 
  
            </span>

        </div>

 
      </div>

      </div>
 
    </div>
 
  </div>
    
 
 
 
 
 <div id="pageButtons" style="overflow: auto">
 
 {{ tablePositionStatusLabel }} of {{ calendarSvc.numberOfRecordsInFilter }} entries
 
 <pagination-template #p="paginationApi"  (pageChange)="pageNumber = $event" class="float-right">
 
   <div class="custom-pagination">
 
     <ul class="pagination pagination">
 
       <li class="page-item">
         <a class="page-link" *ngIf="p.isFirstPage()" (click)="previous()">
             {{targetYear - 1}}
         </a>
       </li>
 
       <li class="page-item">
         <a class="page-link" *ngIf="!p.isFirstPage()" (click)="p.previous(); renderNumberOfEntries()">
           <i class="fa fa-angle-double-left"></i>
         </a>
       </li>
 
       <li class="page-item" *ngFor="let page of p.pages" [class.active]="p.getCurrent() === page.value">
         <a class="page-link" (click)="p.setCurrent(page.value); renderNumberOfEntries()" *ngIf="p.getCurrent() !== page.value">
           <span>{{ page.label }}</span>
         </a>
         <a class="page-link" *ngIf="p.getCurrent() === page.value">
           <span>{{ page.label }}</span>
         </a>
       </li>
 
       <li class="page-item">
         <a class="page-link"  *ngIf="!p.isLastPage()" (click)="p.next(); renderNumberOfEntries()">
             <i class="fa fa-angle-double-right"></i>
         </a>
       </li>
 
       <li class="page-item">
           <a class="page-link" *ngIf="p.isLastPage()" (click)="next()">
               {{targetYear + 1}}
           </a>
       </li>
 
     </ul>
 
   </div>
 
 </pagination-template>
 
 </div>
 
 <a [href]="csvLink" target="csv">CSV Calendar for Liturgical Year {{targetYear}}</a>

 </div>
 